import { render, staticRenderFns } from "./PreferencesCheckboxGroup.vue?vue&type=template&id=4dcb047a&scoped=true&"
import script from "./PreferencesCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./PreferencesCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./PreferencesCheckboxGroup.vue?vue&type=style&index=0&id=4dcb047a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb047a",
  null
  
)

export default component.exports